var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3142 16.2658H9.69187M1 16.6797L5.59366 14.9129C5.88748 14.7999 6.03439 14.7434 6.17183 14.6696C6.29392 14.6041 6.4103 14.5284 6.51977 14.4435C6.64302 14.3478 6.75431 14.2365 6.97691 14.0139L16.3142 4.67664C17.2286 3.76228 17.2286 2.27981 16.3142 1.36546C15.3999 0.451099 13.9174 0.451098 13.0031 1.36545L3.66573 10.7028C3.44314 10.9254 3.33184 11.0367 3.2362 11.1599C3.15125 11.2694 3.07562 11.3858 3.01008 11.5078C2.9363 11.6453 2.8798 11.7922 2.76679 12.086L1 16.6797ZM1 16.6797L2.7037 12.2501C2.82562 11.9331 2.88657 11.7746 2.99113 11.702C3.0825 11.6386 3.19556 11.6146 3.30483 11.6355C3.42985 11.6593 3.54993 11.7794 3.79007 12.0196L5.66013 13.8896C5.90028 14.1298 6.02035 14.2498 6.04422 14.3749C6.06509 14.4841 6.0411 14.5972 5.97765 14.6886C5.90506 14.7931 5.74657 14.8541 5.42959 14.976L1 16.6797Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/penIcon.347f9595a98e2bfc1a0dd2c62245092c.svg";
export { ForwardRef as ReactComponent };